
import { BasicController, BasicProfilingTrackingCommandVO, CommandController, MeasurementVO } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2TutorialController } from "../../Poker2TutorialController";
import { Poker2Command } from "../Poker2Command";

import Event = createjs.Event;

export class GBDCommand extends Poker2Command {
    protected get cmdId(): string {
        return "gbd";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                BasicDialogHandler.getInstance().blockDialogs = false;
                var paramObj: any = JSON.parse(params[1]);
                Poker2Model.userData.parse_GPI(paramObj.gpi);
                Poker2Model.userData.parse_GCU(paramObj.gcu);
                Poker2Model.userData.parse_GXP(paramObj.gxp);
                Poker2Model.userData.parse_GPC(paramObj.gpc);
                Poker2Model.inventoryData.parse_GIN(paramObj.gin);
                Poker2Model.avatarData.parse_AVATAR(paramObj.avatar);
                Poker2Model.giftData.parse_GMG(paramObj.gmg);
                Poker2Model.sessionData.initIgnorList();

                var serverTimestamp: number = NaN;
                if (paramObj.ts != undefined) {
                    // Timestamp from server in seconds. Multiply with 1000 due to the date object in flash caluclates with milliseconds
                    serverTimestamp = Number(paramObj.ts) * 1000;
                }
                else {
                    // Rf server timestamp is not given take the local time instead
                    var localTimestamp: Date = new Date();
                    serverTimestamp = localTimestamp.getTime() / 1000;
                }

                Poker2Model.timestampServer = serverTimestamp;

                if (BasicModel.basicLoaderData.assetLoader.isFinished) {
                    this.getTableList();
                    //						layoutManager.onEndProgressbar();
                }
                else {
                    this.layoutManager.state = BasicLayoutManager.STATE_LOAD_ITEMS;
                    BasicModel.basicLoaderData.assetLoader.addEventListener(Event.COMPLETE, this.bindFunction(this.getTableList));
                }
                if (!Poker2Model.performanceMonitorInitialized) {
                    let vo: BasicProfilingTrackingCommandVO = new BasicProfilingTrackingCommandVO();

                    // define current set of measurements to take
                    vo.measurements = [
                        new MeasurementVO(5, 2, 20, 10 * 60),
                        new MeasurementVO(5, 4, 40, 30 * 60),
                        new MeasurementVO(5, 12, 540, Number.MAX_VALUE)
                    ];

                    // Execute profiling tracking event. Measures at first a given period of time the fps before the event will be send
                    CommandController.instance.executeCommand(BasicController.COMMAND_TRACK_PROFILING, vo);
                    Poker2Model.performanceMonitorInitialized = true;
                }
                this.authenticateToBugsnag();
                break;
            default:
                return super.executeCommand(error, params);
                break;
        }
        return (error == 0);
    }

    private getTableList(e: Event = null): void {
        BasicModel.basicLoaderData.assetLoader.addEventListener(Event.COMPLETE, this.bindFunction(this.getTableList));

        if (this.env.loginIsKeyBased)
            Poker2Model.socialData.setSocialData(Poker2Model.userData.playerID, Poker2Model.userData.userName);

        this.layoutManager.state = 11;
        if (Poker2Model.userData.firstLogin) {
            Poker2TutorialController.getInstance().startTutorial(new Library.PokerTutorial.TutorialArrow());
        }
        else {
            BasicModel.smartfoxClient.sendMessage("tli", [Poker2Model.userData.jsonTableConfig]);
        }
    }

    private authenticateToBugsnag() {
        const bugsnagClient: any = window.bugsnagClient;
        if (!bugsnagClient) return;

        bugsnagClient.user = {
          id: Poker2Model.userData.playerID != -1
                    ? Poker2Model.userData.playerID
                    : Poker2Model.userData.userName,
          name: Poker2Model.userData.userName,
          // stop sending user email to bugsnag
        //   email: Poker2Model.userData.email || undefined
        };
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
